<template>  
  <div class="myMoneyCoreTxlistPage">
      <mu-appbar title="提现记录">
        <div slot="right" class="title-text" @click="open('top')" >
          <p>筛选 </p>    
          <mu-popup position="top" popupClass="myMoneyCoreTxlistPage-popup" :open="topPopup" @close="close('top')">
            <mu-content-block>
              <div class="popuptitle delivery-type-order">
                <div class="button-list">
                  <mu-flat-button @click="searchTypeChange('')" label="全部" :class="searchInfo.state==''?'demo-flat-button select':'demo-flat-button'"/>
                  <mu-flat-button @click="searchTypeChange('0')" label="待处理" :class="searchInfo.state=='0'?'demo-flat-button select':'demo-flat-button'"/>
                  <mu-flat-button @click="searchTypeChange('1')" label="处理中" :class="searchInfo.state=='1'?'demo-flat-button select':'demo-flat-button'"/>
				  <mu-flat-button @click="searchTypeChange('2')" label="已汇款" :class="searchInfo.state=='2'?'demo-flat-button select':'demo-flat-button'"/>
				  <mu-flat-button @click="searchTypeChange('3')" label="已取消" :class="searchInfo.state=='3'?'demo-flat-button select':'demo-flat-button'"/>
                </div>
              </div>              
            </mu-content-block>
          </mu-popup>      
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>
    
	<div>
	<v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" style="background:#fff;margin-top:3px;">
  <div class="gd-content" v-if="!loaded"> 
    <!--<mu-list>-->	
      <dl v-for="aItem in dataList.List">
        <router-link :to="'/usercenter/mymoneycoretxdetail?txNo='+aItem.txNo" :key="aItem.txid">
        <!--
        <mu-list-item  title="">
            <div class="mu-type">{{aItem.bankName}}</div>
            <div class="mu-rmb">{{(aItem.txje).toFixed(2)}}</div>
            <div class="mu-date">{{aItem.statusName}}</div>
            <mu-icon value=":fa fa-angle-right"/>
        </mu-list-item>
        <mu-divider shallowInset/>
        -->
        <dd>
          <i class="mu-icon fa fa-angle-right txright"></i>
          <table>
            <tbody>
              <tr>
                <td class="first-row" rowspan="2"><img :src="getIconByTraceType(aItem.status)"></td>
                <td class="secend-row">
                  <i>{{aItem.bankName}}</i>{{(aItem.txje).toFixed(2)}}
                </td>
              </tr>
              <tr>
                <td class="one-row ">
                  <span class="date">{{aItem.txdatename.split('T')[0]}}</span>
                  <span class="total" v-if="aItem.status == 0 || aItem.status == 1">{{aItem.statusName}}</span>
                  <span class="total" v-if="aItem.status == 2" style="color:#000;">{{aItem.statusName}}</span>
                  <span class="total" v-if="aItem.status == 3" style="color:#ff0303;">{{aItem.statusName}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="line"></div>
        </dd>
        </router-link>
      </dl>	
    <!--</mu-list>-->
    </div>
    </v-scroll>
	</div>
    
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
    <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>
<script>
export default {
  data () {
    return {
      searchType: this.$route.query.type,
      topPopup: false,
      dataList:{
        otherEntity:0,
        List:[]
      },
	  pageEnd : 0, // 结束页数
      num:15,
      searchInfo:{
        pageIndex : 0, // 开始页数
        pageSize:15,
        state:''
      },
      scrollDone:function(){}, 
    }
  },
  mounted(){
    this.getList(true)
  },
  methods: {
    searchTypeChange (val) {
      this.state = val
      this.getList(true)
      this.close('top')
    },
    getList(isNewSearch){
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }
      var ths = this;   
      
      var url = '/Shop/UserServer/GetMoneyCoinTxList'
      
      ths.$post(
        url,this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded = false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
		  if(isNewSearch){            
             ths.dataList.List = []
          } 
        }else{		
          if(isNewSearch){
            ths.dataList.List =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){
              ths.dataList.List.push(res.Data.List[i])
            }
           
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
        }
		if(ths.dataList.List.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },	
    searchTypeChange (val) {
        this.searchInfo.state = val
        this.getList(true)    
        this.close('top')    
    },
    GoHistory(){
      this.$router.goBack()
    },
	onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        done()
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getList(false);     
    },
    getIconByTraceType:function(status){
      if (status == 2){
        return '/static/icon/txsuccess.png';
      } else {
        return '/static/icon/txfail.png';
      }
    },
    open (position) {
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    }
  }
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
       body .myMoneyCoreTxlistPage{
        background: #fff;
      }
      .myMoneyCoreTxlistPage .mu-appbar{
        position: fixed;
        top: 0;
        z-index: 20180101;
      }
      .myMoneyCoreTxlistPage .mu-list{
        top: 56px;
        background: #fff;
      }
      .myMoneyCoreTxlistPage .mu-appbar-title {
        font-size: 16px;
      }
      .myMoneyCoreTxlistPage .title .mu-icon-button {
        position: absolute;
        left: 0;
        top: 0;
        color:white;
      }
      .myMoneyCoreTxlistPage .title .title-text {
        margin: 0;
        padding:0;
        line-height: 48px;
      }
      .myMoneyCoreTxlistPage-popup {
        width: 100%;
        top:46px;
        height: 160px;
        z-index: 1;
        padding: 20px 0;
      }
      .myMoneyCoreTxlistPage-popup .popuptitle .title{
        overflow: hidden;
      }
      .myMoneyCoreTxlistPage-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
      }
      .myMoneyCoreTxlistPage-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
      }
      .myMoneyCoreTxlistPage-popup .button-list{
        padding: 20px 0;
      }
      .myMoneyCoreTxlistPage .right .title-text p{
        font-size: 16px;
      }
      .myMoneyCoreTxlistPage .mu-item-content{
        display: flex;
      }
      .myMoneyCoreTxlistPage .mu-item-content .mu-type,.myMoneyCoreTxlistPage .mu-item-content .mu-rmb,.myMoneyCoreTxlistPage .mu-item-content .mu-date{
        width: 30%;
        text-align: center;
        font-size: 16px;
      }
      .myMoneyCoreTxlistPage-popup .popuptitle .demo-flat-button.select{
        color:red;
      }

.myMoneyCoreTxlistPage .gd-content{
  background: white;
  overflow: hidden;
  position: relative;
}

.myMoneyCoreTxlistPage .gd-content .txright{
  position: absolute;
  right:18px;
  top:18px;
  color:#b8c6c9;
}

.myMoneyCoreTxlistPage .gd-content .line{
  position: absolute;
  right:18px;
  bottom:0;
  background:#F6F6F6;
  width:calc(100% - 32px);
  height:1px;
}
      .myMoneyCoreTxlistPage .gd-content table {
        width: calc(96% - 20px);
        margin-right: 20px;
    }
    .myMoneyCoreTxlistPage .gd-content table td {
        vertical-align:middle;
    }
        .myMoneyCoreTxlistPage .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .myMoneyCoreTxlistPage  .gd-content table td.first-row img {
                width:28px;                
            }

       .myMoneyCoreTxlistPage  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
            color:#000;
        }
       .myMoneyCoreTxlistPage  .gd-content table td.secend-row i{
            float:left;
            color:#000;
            font-style: normal;
        }
        .myMoneyCoreTxlistPage .gd-content table td.one-row {
            padding-bottom:17px;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
        .myMoneyCoreTxlistPage .gd-content table td.one-row .date{
          float: left;
          color:#475b5e;
        }
        .myMoneyCoreTxlistPage .gd-content table td.one-row .total{
          float: right;
        }

           .myMoneyCoreTxlistPage  .gd-content table td.one-row.last {
                border:none;
            }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/myMoneyCoreTxList.vue